import { PREVIEW_REGEX } from '../constants';

function checkPreviewUrl(url, query) {
  if (process.env.BLAZE_DISABLE_PREVIEW) return null;
  const isPreview = url.match(PREVIEW_REGEX);
  if (!isPreview || !query) return null;

  return query;
}

export default checkPreviewUrl;
